exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overflow-hidden[data-v-3ae626ea] {\n  overflow: hidden;\n}\n.send-request__popup[data-v-3ae626ea] .modal-body {\n  max-height: none !important;\n}\n.send-request__popup[data-v-3ae626ea] .modal-content {\n  width: 100%;\n}", ""]);

// exports
